import { useEffect, useState } from 'react';
import { Clientes, ContaAReceber, DadosImpressaoBordero } from '../../../Utils/Types';
import moment from 'moment';
import { Funcoes } from '../../../Utils/Funcoes';

export type Props = {
    visible: boolean,
    pagamentos?: any[],
    dadosCliente?: Clientes,
    dadosDup?: ContaAReceber[]

    dadosReimpressao?: DadosImpressaoBordero
    closeModalEvent: () => void
}

export const ReportReciboContaReceberA4 = ({ visible, pagamentos, dadosCliente, dadosDup, dadosReimpressao, closeModalEvent }: Props) => {

    //const [loading, setLoading] = useState(true)

    const dadosEmpresa = Funcoes.GetDadosEmpresa()

    useEffect(() => {

        if (visible) {

            let modal = document.getElementById('modal_recibo_dupReceber_A4')
            let modalContent = document.getElementById('modal_content_recibo_dupReceber_A4')

            if (modal) {
                modal.style.visibility = 'visible'

                if (modalContent) {
                    modalContent.classList.remove('mt-[-2000px]')
                    modalContent.classList.add('mt-2')
                }
            }

            const printContent = document.getElementById('modal_content_recibo_dupReceber_A4');

            if (printContent) {
                // Abrir uma nova aba
                const printWindow = window.open('novaJanela', 'width=800,height=400', '_blank');

                if (printWindow) {
                    // Escrever o conteúdo na nova aba
                    printWindow.document.open();
                    printWindow.document.write(`
                                                <html>
                                                    <head>
                                                        <title>Impressão</title>
                                                        <script src="https://cdn.tailwindcss.com"></script>
                                                    </head>
                                                    <body>${printContent.innerHTML}</body>
                                                </html>
                                            `);
                    printWindow.document.close();

                    if (typeof closeModalEvent === 'function') {
                        closeModalEvent();
                    }

                } else {
                    console.error("Não foi possível abrir uma nova aba para impressão.");
                }
            } else {
                console.error("Elemento do modal não encontrado.");
            }

            /*
            const modalElement = document.getElementById('modal_content_recibo_dupReceber_A4')?.innerHTML;

            if (modalElement) {
                // Cria um iframe invisível
                const iframe = document.createElement('iframe');
                iframe.style.position = 'absolute';
                iframe.style.width = '0';
                iframe.style.height = '0';
                iframe.style.border = 'none';

                // Adiciona o iframe ao body
                document.body.appendChild(iframe);

                // Aguarda o carregamento do iframe
                iframe.onload = () => {
                    const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;

                    if (iframeDoc) {
                        // Escreve o conteúdo do modal no iframe com o link do Tailwind
                        iframeDoc.open();
                        iframeDoc.write(`
              <html>
                <head>
                  <title>Imprimir</title>
                  <!-- Link para o CSS do Tailwind -->
                  <link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
                </head>
                <body>
                  ${modalElement}
                </body>
              </html>
            `);
                        iframeDoc.close();

                        // Espera o conteúdo carregar e inicia a impressão
                        setTimeout(() => {
                            iframe.contentWindow?.focus();
                            iframe.contentWindow?.print();

                            // Remove o iframe após a impressão
                            document.body.removeChild(iframe);

                            // Fecha o modal
                            if (typeof closeModalEvent === 'function') {
                                closeModalEvent();
                            }
                        }, 500); // Pequeno delay para garantir o carregamento
                    } else {
                        console.error('iframeDoc não encontrado.');
                    }
                };
            } else {
                console.error('Elemento com ID "modal_caixa_report_bobina" não encontrado.');
            }
            */

        } else {

            let modal = document.getElementById('modal_recibo_dupReceber_A4');
            let modalContent = document.getElementById('modal_content_recibo_dupReceber_A4');

            if (modal) {
                modal.style.visibility = 'hidden';

                if (modalContent) {
                    modalContent.classList.add('mt-[-2000px]');
                    modalContent.classList.remove('mt-2');
                }
            }

            //setLoading(true)
        }

        return () => {
            window.onafterprint = null; // Limpa o evento ao desmontar o efeito
        };

    }, [visible])

    

    // ----------------------------------------------------------------- FUNÇÃO PARA SOMAR O TOTAL DO RECIBO --------------------------------------------------
    const somarTotalVenda = (dadosDup: ContaAReceber[]) => {
        if (dadosDup) {
            return dadosDup.reduce((acumulador, item) => acumulador + item.valor, 0);
        }
    };
    const total = somarTotalVenda(dadosDup || []);

    // ----------------------------------------------------------------- FUNÇÃO PARA SOMAR O TOTAL DO RECIBO NA REIMPRESSÃO --------------------------------------------------
    const somarTotalVendaReimpressao = (dados: any[]) => {
        if (dados) {
            return dados.reduce((acumulador, item) => acumulador + item.valor, 0);
        }
    };
    const totalReimpressao = somarTotalVendaReimpressao(dadosReimpressao?.duplicata || []);



    // ----------------------------------------------------------------- FUNÇÃO PARA SOMAR O TOTAL DO DEBITO DO RECIBO  --------------------------------------------------
    const somarDebitos = (dadosVenda: ContaAReceber[]) => {
        if (dadosVenda) {
            return dadosVenda.reduce((acumulador, item) => acumulador + ((item.valor_original + (item?.vl_juros || 0) - (item?.vl_desconto || 0)) - (item.valor)), 0);
        }
    };
    const totalDebito = somarDebitos(dadosDup || []);

    // ----------------------------------------------------------------- FUNÇÃO PARA SOMAR O TOTAL DO DEBITO DO RECIBO  --------------------------------------------------
    const somarDebitosReimpressao = (dadosDebito: any[]) => {
        if (dadosDebito) {
            return dadosDebito.reduce((acumulador, item) => acumulador + ((item.valor_original + (item?.vl_juros || 0) - (item?.vl_desconto || 0)) - (item.valor)), 0);
        }
    };
    const totalDebitoReimpressao = somarDebitosReimpressao(dadosReimpressao?.duplicata || []);



    // ----------------------------------------------------------------- FUNÇÃO PARA SOMAR O TOTAL DO DESCONTO DO RECIBO  --------------------------------------------------
    const somarDesconto = (dadosVenda: ContaAReceber[]) => {
        if (dadosVenda) {
            return dadosVenda.reduce((acumulador, item) => acumulador + (item?.vl_desconto || 0), 0);
        }
    };
    const totalDesconto = somarDesconto(dadosDup || []);

    // ----------------------------------------------------------------- FUNÇÃO PARA SOMAR O TOTAL DO DESCONTO DO RECIBO NA REIMPRESSÃO --------------------------------------------------
    const somarTotalDescontoReimpressao = (dados: any[]) => {
        if (dados) {
            return dados.reduce((acumulador, item) => acumulador + (item?.vl_desconto || 0), 0);
        }
    };
    const totalDescontoReimpressao = somarTotalDescontoReimpressao(dadosReimpressao?.duplicata || []);

    return (
        <div id="modal_recibo_dupReceber_A4" style={{ visibility: "hidden" }} className="fixed top-0 bottom-0 left-0 right-0 z-40 flex justify-center transition-all duration-300">

            <div id="modal_content_recibo_dupReceber_A4" style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', height: 'auto', borderRadius: '0.5rem', marginTop: '-2000px', transition: 'all 0.3s' }}>

                <div style={{ width: "210mm", minHeight: "500px", height: "auto", backgroundColor: "white", padding: '1rem' }}>

                    <span style={{ width: '100%', display: 'flex', justifyContent: 'center', padding: '0.25rem 0', fontSize: '18px', fontWeight: '600', border: '1px solid black', borderLeft: '0', borderRight: '0', borderTop: '0' }}>
                        {dadosEmpresa?.razao || ''}
                    </span>

                    <div style={{ fontSize: '14px', marginTop: '3px', paddingTop: '0.25rem', border: '1px solid black', borderLeft: '0', borderRight: '0', borderBottom: '0' }}>
                        <span style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                            RECIBO DE PAGTO DE CLIENTES
                        </span>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'row', fontSize: '14px', paddingTop: '0.25rem' }}>
                        <span style={{ width: '55%', textAlign: 'left' }}>
                            {'Emissao.: ' + (dadosReimpressao ? moment(dadosReimpressao.duplicata[0].dt_baixa).format("DD/MM/YYYY") : moment(new Date()).format("DD/MM/YYYY"))}
                        </span>
                        <span style={{ width: '45%', textAlign: 'right' }}>
                            {'Horas.: ' + (dadosReimpressao ? moment(dadosReimpressao.duplicata[0].dt_last_update).format("HH:mm") : moment(new Date()).format("HH:mm"))}
                        </span>
                    </div>

                    <div style={{ fontSize: '14px', paddingTop: '0.25rem' }}>
                        <span>
                            {'Cliente.: ' + (dadosCliente ? dadosCliente.nome : dadosReimpressao ? dadosReimpressao.clientes.nome : '')}
                        </span>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'row', fontSize: '14px', padding: '0.25rem 0' }}>
                        <span style={{ width: '60%', textAlign: 'left' }}>
                            {'End.: ' + (dadosCliente ? dadosCliente.endereco : dadosReimpressao ? dadosReimpressao.clientes.endereco : '')}
                        </span>
                        <span style={{ width: '40%', textAlign: 'right' }}>
                            {'Vend: ' + (dadosDup ? dadosDup[0]?.name_user_baixa : dadosReimpressao ? dadosReimpressao.duplicata[0].name_user_baixa : '')}
                        </span>
                    </div>

                    <table style={{ width: '100%', border: '1px solid black', borderBottom: 'none', borderRight: 'none', borderLeft: 'none', fontSize: '12px' }}>
                        <thead>
                            <tr>
                                <th style={{ width: '12%', textAlign: 'left' }}>Venda</th>
                                {/*<th style={{ width: '17%', textAlign: 'center' }}>Emissão</th> */}
                                <th style={{ width: '17%', textAlign: 'center' }}>Vencimento</th>
                                <th style={{ width: '20%', textAlign: 'right' }}>Valor</th>
                                <th style={{ width: '20%', textAlign: 'right' }}>Desconto</th>
                                <th style={{ width: '20%', textAlign: 'right' }}>Val. Pago</th>
                                <th style={{ width: '14%', textAlign: 'right' }}>Debito</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dadosDup && (() => {
                                // --- Calcula os totais ---
                                const totalOriginalComJuros = dadosDup.reduce((acc: number, item: any) => acc + (item.valor_original + item.vl_juros - item.vl_desconto), 0);
                                const totalPago = dadosDup.reduce((acc: number, item: any) => acc + item.valor, 0);

                                const diferencaFinal = totalPago - (totalOriginalComJuros - (dadosDup[dadosDup.length - 1].valor_original + (dadosDup[dadosDup.length - 1].vl_juros || 0) - (dadosDup[dadosDup.length - 1].vl_desconto || 0)));

                                // --- Função auxiliar para valor pago ---
                                const calcularValorExibido = (item: any, index: number) => {
                                    const isLast = index === dadosDup.length - 1;
                                    const valorBase = item.valor_original + item.vl_juros - item.vl_desconto;

                                    // Ajusta só a última linha caso tenha sobra/débito
                                    return isLast ? (totalPago - (totalOriginalComJuros - valorBase)) : valorBase;
                                };

                                // --- Renderiza as linhas ---
                                return dadosDup.map((item: any, index: number) => {
                                    const valorExibido = calcularValorExibido(item, index);
                                    const valorBase = item.valor_original + item.vl_juros - item.vl_desconto;
                                    const debito = valorBase - valorExibido;

                                    return (
                                        <tr key={index}>
                                            <td style={{ width: '12%', textAlign: 'left' }}>{item.id_venda}</td>
                                            <td style={{ width: '17%', textAlign: 'center' }}>{moment(item.data_vencimento).format('DD/MM/YYYY')}</td>
                                            <td style={{ width: '20%', textAlign: 'right' }}>{Funcoes.numberFormat(item.valor_original + item.vl_juros, 'decimal')}</td>
                                            <td style={{ width: '20%', textAlign: 'right' }}>{Funcoes.numberFormat(item.vl_desconto, 'decimal')}</td>
                                            <td style={{ width: '20%', textAlign: 'right' }}>{Funcoes.numberFormat(valorExibido, 'decimal')}</td>
                                            <td style={{ width: '14%', textAlign: 'right' }}>{Funcoes.numberFormat(debito, 'decimal')}</td>
                                        </tr>
                                    );
                                });
                            })()

                            }

                            {dadosReimpressao?.duplicata && (() => {

                                // --- Calcula os totais ---
                                const totalOriginalComJuros = dadosReimpressao?.duplicata.reduce((acc: number, item: any) => acc + (item.valor_original + item.vl_juros - item.vl_desconto), 0);
                                const totalPago = dadosReimpressao?.duplicata.reduce((acc: number, item: any) => acc + item.valor, 0);

                                const diferencaFinal = totalPago - (totalOriginalComJuros - (dadosReimpressao?.duplicata[dadosReimpressao?.duplicata.length - 1].valor_original + (dadosReimpressao?.duplicata[dadosReimpressao?.duplicata.length - 1].vl_juros || 0) - (dadosReimpressao?.duplicata[dadosReimpressao?.duplicata.length - 1].vl_desconto || 0)));

                                // --- Função auxiliar para valor pago ---
                                const calcularValorExibido = (item: any, index: number) => {
                                    const isLast = index === dadosReimpressao?.duplicata.length - 1;
                                    const valorBase = item.valor_original + item.vl_juros - item.vl_desconto;

                                    // Ajusta só a última linha caso tenha sobra/débito
                                    return isLast ? (totalPago - (totalOriginalComJuros - valorBase)) : valorBase;
                                };

                                // --- Renderiza as linhas ---
                                return dadosReimpressao?.duplicata.map((item: any, index: number) => {

                                    const valorExibido = calcularValorExibido(item, index);
                                    const valorBase = item.valor_original + item.vl_juros - item.vl_desconto;
                                    const debito = valorBase - valorExibido;

                                    return (
                                        <tr key={index}>
                                            <td style={{ width: '12%', textAlign: 'left' }}>{item.id_venda}</td>
                                            <td style={{ width: '17%', textAlign: 'center' }}>{moment(item.data_vencimento).format('DD/MM/YYYY')}</td>
                                            <td style={{ width: '20%', textAlign: 'right' }}>{Funcoes.numberFormat(item.valor_original + item.vl_juros, 'decimal')}</td>
                                            <td style={{ width: '20%', textAlign: 'right' }}>{Funcoes.numberFormat(item.vl_desconto, 'decimal')}</td>
                                            <td style={{ width: '20%', textAlign: 'right' }}>{Funcoes.numberFormat(valorExibido, 'decimal')}</td>
                                            <td style={{ width: '14%', textAlign: 'right' }}>{Funcoes.numberFormat(debito, 'decimal')}</td>
                                        </tr>
                                    );
                                });

                            })()

                            }
                        </tbody>
                    </table>

                    <div style={{ display: 'flex', flexDirection: 'row', paddingBottom: '4px' }}>
                        <span style={{ fontSize: '12px', marginTop: '8px', width: '40%' }}>DESCONTO -- </span>
                        <span style={{ fontSize: '12px', marginTop: '8px', width: '29%', textAlign: 'end' }}>{Funcoes.numberFormat((totalDesconto || totalDescontoReimpressao || 0), 'decimal')}</span>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'row', paddingBottom: '4px' }}>
                        <span style={{ fontSize: '12px', marginTop: '8px', width: '40%' }}>TOTAL PAGO NO DIA -- </span>
                        <span style={{ fontSize: '12px', marginTop: '8px', width: '49%', textAlign: 'end' }}>{Funcoes.numberFormat((total || totalReimpressao || 0), 'decimal')}</span>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'row', border: '1px solid black', borderLeft: 'none', borderRight: 'none', borderTop: 'none', paddingTop: '4px' }}>
                        <span style={{ fontSize: '12px', marginTop: '4px', width: '100%' }}>DEBITO RESTANTE  --- </span>
                        <span style={{ fontSize: '12px', marginTop: '4px', width: '100%', textAlign: 'end' }}>{Funcoes.numberFormat((totalDebito || totalDebitoReimpressao || 0), 'decimal')}</span>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'row', marginTop: '8px' }}>
                        <span style={{ fontSize: '14px', width: '40%', marginRight: '4px' }}>Formas de Pagto: </span>
                        <table style={{ fontSize: '14px', width: '100%' }}>
                            <tbody>
                                {(pagamentos || dadosReimpressao?.pagamentos || []).map((item: any, index: any) => (
                                    <tr key={index}>
                                        <td style={{ width: '40%', textAlign: 'start' }}>{pagamentos ? item.description : item.descricao}</td>
                                        <td style={{ width: '10%', textAlign: 'center' }}> -- </td>
                                        <td style={{ width: '50%', textAlign: 'end' }}>{Funcoes.numberFormat(item.valor || 0, 'decimal')}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div style={{ width: '100%', textAlign: 'center', border: '1px solid black', borderLeft: 'none', borderRight: 'none', borderBottom: 'none', marginTop: '70px' }}>
                        <span style={{ fontSize: '14px', width: '100%' }}>Ass. Vendedor</span>
                    </div>

                    <div style={{ width: '100%', marginTop: '40px' }}>
                        <div style={{ minHeight: '80px', height: 'auto', width: '100%', display: 'flex', flexDirection: 'column', fontSize: '14px', padding: '8px 2px' }}>
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                <span style={{ width: '100%' }}>{'Impressao: ' + (moment(new Date()).format("DD/MM/YYYY HH:mm:ss"))}</span>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>


    )
}